<template>
  <v-card :loading="loading" flat>
    <v-card-title>
      <template v-if="!addLink">
        <span class="font-size-sm grey--text">
          لینک‌های خود را "رایگان" کوتاه کنید.
          <br />
          برای انتخاب، روی لینک مورد نظر کلیک کنید.
        </span>
        <v-spacer />

        <v-btn color="success" depressed @click="addLink = true">
          <v-icon left>mdi-plus</v-icon>
          ساخت لینک کوتاه
        </v-btn>
      </template>

      <template v-else>
        <v-spacer />
        <v-btn
          :disabled="loading"
          class="mx-2"
          color="red"
          outlined
          @click="
            () => {
              addLink = false;
              reloadTable();
            }
          "
        >
          <v-icon left>mdi-close</v-icon>
          بازگشت
        </v-btn>

        <v-btn
          :disabled="!canSubmit"
          :loading="loading"
          color="success"
          depressed
          @click="submitNew"
        >
          <v-icon left>mdi-plus</v-icon>
          ساخت لینک کوتاه
        </v-btn>
      </template>
    </v-card-title>

    <v-card-text v-if="!addLink">
      <!-- <data-table
        class="mt-3"
        :columns="columns"
        :data="data"
        :per-page="[10, 25, 50, 100, 400]"
        :translate="translate"
        @on-table-props-changed="reloadTable"
        @row-clicked="selectRow"
      >
        <template v-slot:link="{ item }">
          <span class="truncate-text">{{ item.link }}</span>
        </template>
      </data-table> -->
      <vue-table
        class="mt-3"
        :translate="translate"
        :data="data"
        :headers="headers"
        :loading="loading"
        :props.sync="tableProps"
        :per-page-items="[10, 25, 50, 100, 400]"
        @on-table-props-changed="reloadTable"
        @row-clicked="selectRow"
        @change="onPagination"
      >
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="1" md="2">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                label="تعداد"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="4" md="6">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                label="جستجو"
                outlined
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:index="{ item }">
          {{ item.index + 1 + (data.current_page - 1) * data.per_page }}
        </template>

        <template v-slot:link="{ item }">
          <div class="slink">
            <span class="truncate-text">{{ item.link }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attr }">
                <v-btn
                  class="mr-2"
                  icon
                  small
                  v-bind="attr"
                  v-on="on"
                  @click.stop="copyLink(item.link)"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>

              <span>کپی لینک</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:shortlink="{ item }">
          <div class="slink">
            <span class="truncate-text">{{ item.shortlink }}</span>
            <v-tooltip left>
              <template v-slot:activator="{ on, attr }">
                <v-btn
                  class="mr-2"
                  icon
                  small
                  v-bind="attr"
                  v-on="on"
                  @click.stop="copyLink(item.shortlink)"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>

              <span>کپی لینک کوتاه</span>
            </v-tooltip>
          </div>

          <!-- <copy-link-btn :link="item.shortlink" /> -->
        </template>
        <template v-slot:viewsC="{ item }">
          <span>{{ persian(item.viewsC) }} </span>
        </template>

        <template v-slot:action="{ item }">
          <short-link-buttons :data="item" :meta="metaButtons" />
        </template>
      </vue-table>
    </v-card-text>

    <v-row v-else class="p-1" no-gutters>
      <v-col class="pa-2" cols="12" md="6">
        <v-text-field
          v-model="linkObj.title"
          clear-icon="mdi-close-circle-outline"
          clearable
          :rules="[
            (v) => !!v || 'عنوان الزامی است',
            (v) => (v && v.length >= 4) || 'حداقل 4 کاراکتر مجاز است',
          ]"
          dense
          label="عنوان"
          placeholder="لطفا یک نام برای لینک کوتاه خود اضافه کنید."
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12" md="6">
        <v-text-field
          v-model="linkObj.link"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          :rules="[
            (v) => !!v || 'لینک الزامی است',
            (v) => /^https:\/\//.test(v) || 'لینک باید با https:// شروع شود',
          ]"
          label="لینک"
          placeholder="لینک مورد نظر خود را وارد کنید."
          outlined
        />
      </v-col>

      <v-col class="pa-2" cols="12">
        <v-select
          v-model="linkObj.domainId"
          :items="domainItems"
          dense
          label="انتخاب دامنه"
          outlined
          readonly
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { debounce } from "@/main";
import shortLinkButtons from "@/view/content/shortLink/shortLinkButtons.vue";
import copyLinkBtn from "@/view/content/shortLink/copyLinkBtn.vue";

export default {
  name: "selectShortLink",

  props: {
    value: String,
  },
  components: { shortLinkButtons },

  data() {
    return {
      data: {},
      metaButtons: {
        buttons: [
          {
            name: "removeLink",
            label: "حذف",
            icon: "trash",
            class: "btn-delete border-2 rounded-pill",
            action: this.action,
          },
        ],
      },

      columns: [
        {
          label: "ردیف",
          name: "row",
          transform: (data) => {
            return data.row + 1;
          },
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
        },
        {
          label: "عنوان",
          name: "title",
        },
        {
          label: "لینک",
          name: "link",
          component: copyLinkBtn,
          class: "truncate-text",
        },
        {
          label: "لینک کوتاه شده",
          name: "shortlink",
          component: copyLinkBtn,
        },
        {
          label: "تعداد کلیک",
          name: "viewsC",
        },
        {
          label: "مدیریت",
          name: "action",
          component: shortLinkButtons,
          event: "actions",
          handler: this.action,
          meta: {
            buttons: [
              {
                name: "removeLink",
                label: "حذف",
                icon: "trash",
                class: "btn-delete border-2 rounded-pill",
                action: this.action,
              },
            ],
          },
        },
      ],
      tableProps: {
        search: "",
        filters: {},
        status: null,
        length: 10,
        column: "id",
        dir: "desc",
      },
      translate: {
        noDataText: "داده ای برای نمایش وجود ندارد",
        noResultsText: "موردی یافت نشد",
        loadingText: "در حال بارگذاری...",
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        placeholderSearch: "جستجو",
      },
      loading: false,
      addLink: false,
      rules: {
        empty: (v) => (!!v && v.length > 3) || "عنوان الزامی می‌باشد.",
        link: (v) => (!!v && this.isDomain(v)) || "لطفا لینک صحیح وارد نمایید.",
      },
      domainItems: [
        {
          value: 1,
          text: "t7r.ir",
        },
      ],
      linkObj: {
        title: "",
        link: "",
        type_id: 1,
        domainId: 1,
        password: null,
        favoriteLink: null,
      },
    };
  },

  created() {
    this.fetchLinks(this.tableProps);
  },

  computed: {
    // computedValue: {
    //   get() {
    //     return this.value
    //   },
    //   set(val) {
    //     this.$emit('input', val)
    //   }
    // },
    headers() {
      return [
        { text: "ردیف", value: "index", sortable: false, align: "center" },
        { text: "شناسه", value: "id", sortable: false, align: "center" },
        { text: "عنوان", value: "title", sortable: false, align: "center" },
        { text: "لینک", value: "link", sortable: false, align: "center" },
        {
          text: "لینک کوتاه شده",
          value: "shortlink",
          sortable: false,
          align: "center",
        },
        {
          text: "تعداد کلیک",
          value: "viewsC",
          sortable: false,
          align: "center",
        },
        { text: "مدیریت", value: "action", sortable: false, align: "center" },
      ];
    },
    canSubmit() {
      return (
        typeof this.rules.empty(this.linkObj.title) === "boolean" &&
        typeof this.rules.link(this.linkObj.link) === "boolean"
      );
    },
  },
  watch: {},
  methods: {
    fetchLinks(props = this.tableProps) {
      this.loading = true;
      this.$api
        .get(this.$shortLinkApi + "/link", {
          params: props,
        })
        .then(({ data }) => {
          this.data = data;
          const updatedData = data.data.map((item) => ({
            ...item,
            shortlink: `${item.domains.domain}/${item.code}`,
          }));
          this.data.data = updatedData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.fetchLinks(props);
    },

    reloadTable(props) {
      debounce(() => this.fetchLinks(props), 500);
    },
    selectRow(data) {
      const id = data.id;

      $("tr").css("background", "");

      $(`tr:contains("${id}")`).each(function (index, item) {
        if ($(item).find("td").eq(1).text() == id)
          $(item).css("background", "rgba(99, 0, 244, 0.28)");
      });

      // this.computedValue = data;
      // this.dialog = false;
      // this.computedValue = data.link
      this.$emit("select", data.shortlink);
      this.$emit("close");
    },
    submitNew() {
      this.loading = true;

      this.$api
        .post(this.$shortLinkApi + "/add/link", this.linkObj)
        .then(({ data }) => {
          this.$toast.success("با موفقیت اضافه شد.");
          this.addLink = false;
          this.reloadTable();
        })
        .catch(({ response }) =>
          console.log("failed to add new link: ", response)
        )
        .finally(() => (this.loading = false));
    },
    action(data, type) {
      this[type](data);
    },
    async removeLink(data) {
      if (await this.$modal.yesNo("تایید حذف لینک کوتاه؟")) {
        this.loading = true;

        this.$api
          .delete(`/link/delete/${data.id}`)
          .then(({ data }) => {
            this.tableProps.page = 1;
            this.$nextTick(() => {
              this.reloadTable();
            });
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>

<style scoped>
.v-card >>> .laravel-vue-datatable-tbody-tr {
  cursor: pointer;
}
::v-deep .truncate-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80px;
}
/* Responsive حرفه‌ای برای پاپ‌آپ لینک کوتاه */
.shortlink-dialog {
  width: 95vw !important;
  max-width: 460px !important; /* موبایل و تبلت */
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2) !important;
}

@media (min-width: 600px) {
  .shortlink-dialog {
    max-width: 560px !important;
  }
}

@media (min-width: 960px) {
  .shortlink-dialog {
    max-width: 800px !important;
  }
}

@media (min-width: 1264px) {
  .shortlink-dialog {
    max-width: 900px !important;
  }
}

.shortlink-dialog .v-card {
  height: 80vh;
  max-height: 700px;
  display: flex;
  flex-direction: column;
}

.shortlink-dialog .v-card__text {
  flex: 1;
  overflow-y: auto;
  padding: 0 !important;
}
.slink {
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  justify-items: center;
}
</style>
